"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TasksComponent = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable no-case-declarations */
var react_1 = require("react");
var bi_1 = require("react-icons/bi");
var md_1 = require("react-icons/md");
var __1 = require("../../..");
var react_2 = require("@escolalms/sdk/lib/react");
var date_fns_1 = require("date-fns");
var i18next_1 = require("i18next");
var styles_1 = require("./styles");
var styled_components_1 = __importStar(require("styled-components"));
var ModalDeleteTask_1 = require("../ModalDeleteTask");
var TaskDetailsModal_1 = require("../TaskDetailsModal");
var RelatedTreeSelect_1 = require("../../molecules/RelatedTreeSelect");
var ChangeStatusCheckbox = function (_a) {
    var id = _a.id, onSuccess = _a.onSuccess, disabled = _a.disabled, props = __rest(_a, ["id", "onSuccess", "disabled"]);
    var _b = (0, react_1.useState)(false), isLoading = _b[0], setIsLoading = _b[1];
    var updateTaskStatus = (0, react_1.useContext)(react_2.EscolaLMSContext).updateTaskStatus;
    return ((0, jsx_runtime_1.jsx)(__1.Checkbox, __assign({}, props, { disabled: isLoading || disabled, onChange: function (e) {
            setIsLoading(true);
            updateTaskStatus(id, e.target.checked)
                .then(function () {
                setIsLoading(false);
                onSuccess();
            })
                .catch(function () { return setIsLoading(false); });
        } })));
};
var TasksComponent = function (_a) {
    var _b;
    var sortOptions = _a.sortOptions, taskShowAction = _a.taskShowAction, createBy = _a.createBy, tasksPagination = _a.tasksPagination;
    var _c = (0, react_1.useState)({
        addTask: false,
        deleteTask: false,
        editTask: false,
    }), isModalVisible = _c[0], setIsModalVisible = _c[1];
    var _d = (0, react_1.useState)(), taskForActions = _d[0], setTaskForActions = _d[1];
    var _e = (0, react_1.useContext)(react_2.EscolaLMSContext), fetchTasks = _e.fetchTasks, addTask = _e.addTask, deleteTask = _e.deleteTask, tasks = _e.tasks;
    var tasksList = (_b = tasks.list) === null || _b === void 0 ? void 0 : _b.data;
    var pagination = (0, react_1.useState)({
        current: 0,
        pageSize: 100,
    })[0];
    var closeModal = function (key) {
        return setIsModalVisible(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[key] = false, _a)));
        });
    };
    var openModal = function (key) {
        return setIsModalVisible(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[key] = true, _a)));
        });
    };
    var checkDate = function (date) {
        if ((0, date_fns_1.isToday)(new Date(date)))
            return "Today";
        if ((0, date_fns_1.isTomorrow)(new Date(date)))
            return "Tomorrow";
        if ((0, date_fns_1.isBefore)(new Date(date), new Date()))
            return "Overdue";
        if ((0, date_fns_1.isAfter)(new Date(date), new Date()))
            return "Upcoming";
    };
    var checkCreateBy = function (tasks, create) {
        var checkedTasks = tasks !== null && tasks !== void 0 ? tasks : [];
        return checkedTasks.filter(function (task) {
            var _a, _b, _c, _d;
            return create === "Personal"
                ? ((_a = task.created_by) === null || _a === void 0 ? void 0 : _a.id) === ((_b = task.user) === null || _b === void 0 ? void 0 : _b.id)
                : ((_c = task.created_by) === null || _c === void 0 ? void 0 : _c.id) !== ((_d = task.user) === null || _d === void 0 ? void 0 : _d.id);
        });
    };
    var sortTasks = function (tasksToSort, sortType) {
        var checkedTasksToSort = tasksToSort || [];
        switch (sortType) {
            case "Ascending":
                return checkedTasksToSort.sort(function (a, b) {
                    return new Date(a.due_date).valueOf() - new Date(b.due_date).valueOf();
                });
            default:
                return checkedTasksToSort.sort(function (a, b) {
                    return new Date(b.due_date).valueOf() - new Date(a.due_date).valueOf();
                });
        }
    };
    var filterTasks = function (tasks, type, create) {
        var sortedTasks = sortTasks(tasks, sortOptions.type);
        var toDoTasks = sortedTasks.filter(function (task) { return task.completed_at === null; });
        var getTaskArray = function () {
            return taskShowAction.showDone ? sortedTasks : toDoTasks;
        };
        switch (type) {
            case (0, i18next_1.t)("Tasks.TodayTasks"):
                var today = getTaskArray().filter(function (task) {
                    return (0, date_fns_1.isToday)(new Date(task.due_date));
                });
                return checkCreateBy(today, create);
            case (0, i18next_1.t)("Tasks.UpcomingTasks"):
                var upcoming = getTaskArray().filter(function (task) {
                    return (0, date_fns_1.isAfter)(new Date(task.due_date), new Date()) &&
                        !(0, date_fns_1.isToday)(new Date(task.due_date));
                });
                return checkCreateBy(upcoming, create);
            case (0, i18next_1.t)("Tasks.OverdueTasks"):
                var overdue = getTaskArray().filter(function (task) {
                    return (0, date_fns_1.isBefore)(new Date(task.due_date), new Date()) &&
                        !(0, date_fns_1.isToday)(new Date(task.due_date));
                });
                return checkCreateBy(overdue, create);
            default:
                return checkCreateBy(getTaskArray(), create);
        }
    };
    var listItems = [
        {
            id: 0,
            icon: (0, jsx_runtime_1.jsx)(bi_1.BiListUl, { size: "1.2em" }),
            text: (0, i18next_1.t)("Tasks.AllTasks"),
            numberOfItems: tasksList
                ? filterTasks(tasksList, (0, i18next_1.t)("Tasks.AllTasks"), createBy.type).length
                : 0,
        },
        {
            id: 1,
            icon: (0, jsx_runtime_1.jsx)(bi_1.BiListCheck, { size: "1.2em" }),
            text: (0, i18next_1.t)("Tasks.TodayTasks"),
            numberOfItems: tasksList
                ? filterTasks(tasksList, (0, i18next_1.t)("Tasks.TodayTasks"), createBy.type).length
                : 0,
        },
        {
            id: 2,
            icon: (0, jsx_runtime_1.jsx)(bi_1.BiListPlus, { size: "1.2em" }),
            text: (0, i18next_1.t)("Tasks.UpcomingTasks"),
            numberOfItems: tasksList
                ? filterTasks(tasksList, (0, i18next_1.t)("Tasks.UpcomingTasks"), createBy.type).length
                : 0,
        },
        {
            id: 3,
            icon: (0, jsx_runtime_1.jsx)(bi_1.BiListMinus, { size: "1.2em" }),
            text: (0, i18next_1.t)("Tasks.OverdueTasks"),
            numberOfItems: tasksList
                ? filterTasks(tasksList, (0, i18next_1.t)("Tasks.OverdueTasks"), createBy.type).length
                : 0,
        },
    ];
    var taskAction = [
        {
            id: 10,
            content: ((0, jsx_runtime_1.jsx)(__1.IconText, { icon: (0, jsx_runtime_1.jsx)(md_1.MdEditNote, {}), text: "Edit", onClick: function () { return openModal("editTask"); } })),
        },
        {
            id: 20,
            content: ((0, jsx_runtime_1.jsx)(__1.IconText, { icon: (0, jsx_runtime_1.jsx)(md_1.MdDeleteForever, {}), text: "Delete", onClick: function () { return openModal("deleteTask"); } })),
        },
    ];
    var refreshTasks = function () { return fetchTasks(pagination); };
    var handleDeleteTask = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = taskForActions;
                    if (!_a) return [3 /*break*/, 2];
                    return [4 /*yield*/, deleteTask(taskForActions.id)];
                case 1:
                    _a = (_b.sent());
                    _b.label = 2;
                case 2:
                    _a;
                    return [4 /*yield*/, fetchTasks(pagination)];
                case 3:
                    _b.sent();
                    closeModal("deleteTask");
                    return [2 /*return*/];
            }
        });
    }); };
    var addTaskButton = {
        title: (0, i18next_1.t)("Tasks.add", {
            defaultValue: "Add task",
        }),
        onClick: function () { return openModal("addTask"); },
    };
    var _f = (0, react_1.useState)(0), selectedListItem = _f[0], setSelectedListItem = _f[1];
    var currentlySelectedListItem = listItems.find(function (_a) {
        var id = _a.id;
        return id === selectedListItem;
    });
    var tasksToShowInList = function () {
        return filterTasks(tasksList, String(currentlySelectedListItem === null || currentlySelectedListItem === void 0 ? void 0 : currentlySelectedListItem.text), createBy.type);
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(styles_1.TasksContainer, { children: [(0, jsx_runtime_1.jsxs)(styles_1.TasksHeader, { children: [(0, jsx_runtime_1.jsx)(__1.Title, __assign({ level: 4 }, { children: (0, i18next_1.t)("Tasks.TasksHeader") })), (0, jsx_runtime_1.jsx)(__1.Button, __assign({ onClick: addTaskButton.onClick, mode: "secondary" }, { children: (0, i18next_1.t)("Tasks.AddTask") }))] }), (0, jsx_runtime_1.jsxs)(styles_1.TasksBody, { children: [(0, jsx_runtime_1.jsx)(styles_1.TasksMenu, { children: (0, jsx_runtime_1.jsx)(__1.List, { listItems: listItems, selectedListItem: selectedListItem, setSelectedListItem: setSelectedListItem }) }), (0, jsx_runtime_1.jsxs)(styles_1.TasksContent, { children: [(0, jsx_runtime_1.jsxs)(styles_1.TasksContentHeader, { children: [(0, jsx_runtime_1.jsx)(__1.Title, { children: currentlySelectedListItem === null || currentlySelectedListItem === void 0 ? void 0 : currentlySelectedListItem.text }), (0, jsx_runtime_1.jsx)(__1.DropdownMenu, { child: (0, jsx_runtime_1.jsx)(__1.Text, __assign({ size: "12", noMargin: true }, { children: "".concat((0, i18next_1.t)("Tasks.CreateBy"), ": ").concat((0, i18next_1.t)("Tasks.".concat(createBy.type))) })), menuItems: createBy.options }), (0, jsx_runtime_1.jsx)(__1.DropdownMenu, { child: (0, jsx_runtime_1.jsx)(__1.Text, __assign({ size: "12", noMargin: true }, { children: "".concat((0, i18next_1.t)("Tasks.Sort"), ": ").concat((0, i18next_1.t)("Tasks.".concat(sortOptions.type))) })), menuItems: sortOptions.options }), (0, jsx_runtime_1.jsx)(__1.DropdownMenu, { child: (0, jsx_runtime_1.jsx)(md_1.MdMoreHoriz, { size: "1.6em" }), menuItems: taskShowAction.options })] }), tasksToShowInList().map(function (item) {
                                        var id = item.id, title = item.title, completed_at = item.completed_at, related_type = item.related_type, related_id = item.related_id;
                                        var checkedDate = checkDate(String(item.due_date));
                                        return ((0, jsx_runtime_1.jsxs)(styles_1.TaskItem, { children: [(0, jsx_runtime_1.jsxs)(__1.Row, __assign({ "$gap": 16 }, { children: [(0, jsx_runtime_1.jsx)(ChangeStatusCheckbox, { id: id, "aria-labelledby": "".concat(id, "-label"), checked: !!completed_at, onSuccess: refreshTasks }), (0, jsx_runtime_1.jsxs)(__1.Stack, { children: [(0, jsx_runtime_1.jsx)(styles_1.StyledTitle, __assign({ id: "".concat(id, "-label"), "$isCompleted": !!completed_at, as: "h2" }, { children: title })), related_type && ((0, jsx_runtime_1.jsx)(styles_1.ProgrammeText, { children: (0, jsx_runtime_1.jsx)(RelatedTreeSelect_1.RelatedTreeSelect, { disabled: true, value: "".concat(related_type, ":").concat(related_id) }) }))] })] })), (0, jsx_runtime_1.jsxs)(styles_1.TaskDateWrapper, { children: [(0, jsx_runtime_1.jsx)(styles_1.TaskDate, __assign({ "$date": checkedDate }, { children: (0, jsx_runtime_1.jsx)(__1.Text, { children: (0, i18next_1.t)("Tasks.".concat(checkedDate)) }) })), (0, jsx_runtime_1.jsx)(__1.DropdownMenu, { onClick: function () {
                                                                return item !== taskForActions && setTaskForActions(item);
                                                            }, child: (0, jsx_runtime_1.jsx)(md_1.MdMoreHoriz, { size: "1.6em" }), menuItems: taskAction })] })] }, id));
                                    }), tasksToShowInList().length === 0 && ((0, jsx_runtime_1.jsx)(__1.Text, { children: (0, i18next_1.t)("Tasks.NoTasks") }))] })] }), (0, jsx_runtime_1.jsxs)(styles_1.TasksPage, { children: [(0, jsx_runtime_1.jsx)(__1.Button, __assign({ type: "button", mode: "outline", disabled: tasksPagination.previousDisabled, onClick: function () {
                                    return tasksPagination.setCurrentPage(tasksPagination.currentPage - 1);
                                } }, { children: (0, i18next_1.t)("Bookmarks.Prev") })), (0, jsx_runtime_1.jsx)(__1.Title, { children: "".concat((0, i18next_1.t)("Bookmarks.Page"), " ").concat(tasksPagination.currentPage, " / ").concat(tasksPagination.lastPage || 1) }), (0, jsx_runtime_1.jsx)(__1.Button, __assign({ type: "button", mode: "outline", disabled: tasksPagination.nextDisabled, onClick: function () {
                                    return tasksPagination.setCurrentPage(tasksPagination.currentPage + 1);
                                } }, { children: (0, i18next_1.t)("Bookmarks.Next") }))] })] }), (0, jsx_runtime_1.jsx)(__1.Modal, __assign({ visible: isModalVisible.addTask, onClose: function () { return closeModal("addTask"); }, animation: "zoom", maskAnimation: "fade", destroyOnClose: true, width: 800 }, { children: (0, jsx_runtime_1.jsx)(__1.ModalAddTask, { refreshTasks: refreshTasks, addTask: addTask, onSuccess: function () {
                        closeModal("addTask");
                    }, onCancel: function () { return closeModal("addTask"); } }) })), (0, jsx_runtime_1.jsx)(__1.Modal, __assign({ visible: isModalVisible.editTask, onClose: function () { return closeModal("editTask"); }, animation: "zoom", maskAnimation: "fade", destroyOnClose: true, width: 800 }, { children: (0, jsx_runtime_1.jsx)(TaskDetailsModal_1.TaskDetailsModal, { task: taskForActions, closeModal: function () { return closeModal("editTask"); }, onTaskUpdateSuccess: refreshTasks, onTaskStatusUpdateSuccess: refreshTasks }) })), (0, jsx_runtime_1.jsx)(__1.Modal, __assign({ visible: isModalVisible.deleteTask, onClose: function () { return closeModal("deleteTask"); }, animation: "zoom", maskAnimation: "fade", destroyOnClose: true, width: 800 }, { children: (0, jsx_runtime_1.jsx)(ModalDeleteTask_1.ModalDeleteTask, { handleDelete: handleDeleteTask, handleClose: function () { return closeModal("deleteTask"); } }) }))] }));
};
exports.TasksComponent = TasksComponent;
exports.default = (0, styled_components_1.withTheme)((0, styled_components_1.default)(exports.TasksComponent)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""]))));
var templateObject_1;
